<template>
  <Layout :hasBackButton="true" :hasBreadcrumbs="false" :amount="0" :amountToShow="0">
    <div class="content">
      <div class="page-content">
        <MainTitle :title="this.$router.currentRoute.name" />
        <SearchBar @input="gotSearchterm"/>
        <SearchTables :allResults="searchResult" @getSelection="gotSelection"/>
      </div>
    </div>
    <SearchDetailModal v-if="hasItemSelected" :selectedItem="selectedSearchItem" @closeModal="closeModal"/>
  </Layout>
</template>
<script>

import Layout from "@/layouts/Dashboard";
import SearchTables from "@/components/SearchTables";
import SearchBar from "@/components/SearchBar";
import MainTitle from "@/components/base/MainTitle";
import TableDetail from "@/components/TblLotDetail";
import SearchDetailModal from "@/components/SearchDetailModal";

export default {
  name: "search",
  data () {
    return {
      searchterm: "",
      searchResult: {},
      selectedSearchItem: null,
      hasItemSelected: false
    }
  },
  components: {
    Layout,
    MainTitle, 
    TableDetail,
    SearchBar,
    SearchTables,
    SearchDetailModal
  },
  mounted() {
  },
  methods: {
    gotSearchterm(val) {
      this.searchterm = val
      this.getResults()
    },
    getResults() {
      var that = this
      if(that.searchterm != "") {
        this.$http.get(this.$endpoint + 'master/search/' + this.searchterm)
        .then(response => {
          that.searchResult = response.data
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
            .dispatch("logout")
            .then(() => this.$router.push("/login"))
            .catch(err => console.log(err));
          } else {
            that.$swal(
              'Oops that went wrong?',
              `Please contact the admin with the following info: ${ error }`,
              'error'
            );
          }
        })
      } else {
        that.searchResult = {}
      }
    },
    gotSelection(item) {
      this.selectedSearchItem = item
      this.hasItemSelected = true
    },
    closeModal(){
      this.selectedSearchItem = null
      this.hasItemSelected = false
    }
  },
  watch: {

  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;
